import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { asChakraVariable } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'
import { IncomingCallButtonVariants } from './IncomingCallButton.style'

const {
  IncomingCallButton: { CallIcons: Colors },
} = phoneColorKeys.Phone

const callIconParts = ['container', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(callIconParts)
export const CallIconStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      boxSize: '3.75rem',
      borderRadius: 'full',
      border: '2px solid',
    },
    icon: {
      boxSize: '1.5rem',
    },
  },
  variants: {
    [IncomingCallButtonVariants.Reject]: {
      container: {
        backgroundColor: Colors.Reject.Button,
        borderColor: Colors.Reject.Border,
      },
      icon: {
        color: Colors.Reject.Icon,
      },
    },
    [IncomingCallButtonVariants.Accept]: {
      container: {
        backgroundColor: Colors.Accept.Button,
        borderColor: Colors.Accept.Border,
      },
      icon: {
        color: Colors.Accept.Icon,
      },
    },
    [IncomingCallButtonVariants.AcceptWithOverlap]: {
      container: {
        backgroundColor: Colors.Accept.Button,
        borderColor: Colors.Accept.Border,
        marginLeft: '-0.75rem',
        boxShadow: `0px 4px 8px 0px ${asChakraVariable(Colors.Accept.BoxShadow)}`,
      },
      icon: {
        color: Colors.Accept.Icon,
      },
    },
    [IncomingCallButtonVariants.EndAndAccept]: {
      container: {
        backgroundColor: Colors.Reject.Button,
        borderColor: Colors.Reject.Border,
      },
      icon: {
        color: Colors.Reject.Icon,
      },
    },
    [IncomingCallButtonVariants.HoldAndAccept]: {
      container: {
        backgroundColor: Colors.Hold.Button,
        borderColor: Colors.Hold.Border,
      },
      icon: {
        color: Colors.Hold.Icon,
      },
    },
    [IncomingCallButtonVariants.ParkAndAccept]: {
      container: {
        backgroundColor: Colors.Hold.Button,
        borderColor: Colors.Hold.Border,
      },
      icon: {
        color: Colors.Hold.Icon,
      },
    },
  },
})

export const useCallIconStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof callIconParts>(
    getName({ CallIconStyle }),
    props,
  )
}
